const RE = /^VITE_/;
const Environment = Object.fromEntries(Object.entries(import.meta.env).flatMap(([k, v]) => RE.test(k) ? [[k.replace(RE, ""), v]] : []));

export const {API_URL, GOOGLE_MAPS_API_KEY, GOOGLE_OAUTH_CLIENT_ID, GOOGLE_RECAPTCHA_SITE_KEY, LINKEDIN_CLIENT_ID} = Environment;